import api from "../../api";

/** @type {import("vuex").Module} */
export const ui = {
    namespaced: true,
    state: {
        logo: {
            pc: "/images/logo.png",
            mobile: "/images/logo2.png",
        },
    },
    mutations: {
        setLogo(state, { logo }) {
            state.logo = logo;
        },
    },
    actions: {
        async getLogo({ commit }) {
            const { logos: pcLogos } = await api.v1.common.logos.gets({
                params: { shows: true, type: "pc" },
            });
            const { logos: mbLogos } = await api.v1.common.logos.gets({
                params: { shows: true, type: "mobile" },
            });

            let pc = pcLogos[0]?.image ? pcLogos[0].image : "/images/logo.png";
            let mobile = mbLogos[0]?.image ? mbLogos[0].image : "/images/logo2.png";
            
            commit("setLogo", { logo: { pc, mobile } });
        },
    },
};
